import {
  Anchor,
  Collapse,
  Group,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconCaretDown, IconCaretUp } from "@tabler/icons-react"
import { CodeCell } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { FindCertificateRequestsForSupplierResponseDto } from "~/gen/api"

interface Props {
  certificateRequest: FindCertificateRequestsForSupplierResponseDto
}

export const CertificateRequestPurchaseOrder = ({
  certificateRequest,
}: Props) => {
  const [open, { toggle }] = useDisclosure(false)
  const { colors } = useMantineTheme()
  const { t } = useTranslation(["traceability"])

  return (
    <Stack gap="xs">
      <Group>
        <Group gap="xs">
          <Text size="sm">{t("certificates.labels.purchaseOrder")}</Text>
          <CodeCell
            value={certificateRequest.operationPurchaseOrderReference}
          />
        </Group>
        <Anchor fw={700} size="xs" onClick={toggle}>
          <Group gap={4} align="center">
            {open ? (
              <Text>{t("certificates.purchaseOrder.actions.seeLess")}</Text>
            ) : (
              <Text> {t("certificates.purchaseOrder.actions.seeMore")}</Text>
            )}
            {open ? (
              <IconCaretUp size={16} color={colors.green[5]} />
            ) : (
              <IconCaretDown size={16} color={colors.green[5]} />
            )}
          </Group>
        </Anchor>
      </Group>
      <Collapse in={open}>
        <Stack gap={4} pl="sm">
          <Text size="sm">
            {t("certificates.purchaseOrder.productReferences")}
          </Text>

          <Group>
            <Text size="sm">{certificateRequest.product.brandReference}</Text>
            {certificateRequest.product.color && (
              <Text size="sm">{certificateRequest.product.color}</Text>
            )}
          </Group>
        </Stack>
      </Collapse>
    </Stack>
  )
}
